import React                          from 'react';
import PropTypes                      from 'prop-types'

import CustomPriceMatrixCell          from '../CustomPriceMatrixCell';

const MobilePriceMatrixRow = (props) => {
  return (
    <tr className={props.hiddenRow ? 'd-none' : ''}>
      <td className="qty">{props.quantity}</td>
      {props.leadTimes.map((leadTime, col) => (
        <CustomPriceMatrixCell
          key={col}
          leadTime={leadTime}
          prefix_name={props.prefix_name}
          col={col}
          {...props} />
      ))}
    </tr>
  );
};

MobilePriceMatrixRow.defaultProps = {
  leadTimes: [],
};

MobilePriceMatrixRow.propTypes = {
  quantity: PropTypes.number.isRequired,
  leadTimes: PropTypes.array.isRequired,
  hiddenRow: PropTypes.bool.isRequired,
}

export default MobilePriceMatrixRow;

